import { createDeviceDetector } from "next-vue-device-detector";

export const device = createDeviceDetector();
